const DEFAULT_TTL_MS = 24 * 60 * 60 * 1000; // 24h

export function getLocalCache(key, ttlMs = DEFAULT_TTL_MS) {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    const { value, ts } = parsed;
    if (!ts || Date.now() - ts > ttlMs) return null;
    return value ?? null;
  } catch {
    return null;
  }
}

export function setLocalCache(key, value) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(
      key,
      JSON.stringify({ value, ts: Date.now() }),
    );
  } catch {
    // ignore quota / serialization errors
  }
}

